<template>
  <div class="sp_myAssetsList">
    <div v-if="showContent"
         class="content">
      <heade-title :title="title"></heade-title>

      <!-- 公告区域 -->
      <el-row v-if="showDeviceNotice" style="background-color: #f0f3f7; border: none; color: red;font-size: 14px;">
        <el-col>{{deviceNotice}}</el-col>
      </el-row>
      <div class="background"></div>

      <!-- 搜索区域 -->
      <el-row style="background-color: #f0f3f7;
    border: none;"
              :gutter="4">
        <el-col :span="5">
          <el-date-picker size="small"
                          v-model="filter.addedTime"
                          @change="conditionSearch()"
                          type="daterange"
                          range-separator="-"
                          start-placeholder="Added Start Time"
                          end-placeholder="Added End Time"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-col>
        <el-col :span="5">
          <el-date-picker size="small"
                          v-model="filter.expiredTime"
                          @change="conditionSearch()"
                          type="daterange"
                          range-separator="-"
                          start-placeholder="Expired Start Time"
                          end-placeholder="Expired End Time"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-select clearable
                     v-model="filter.licStatus"
                     placeholder="Status"
                     size="small"
                     @change="conditionSearch()"
                     style="width:100%;">
            <el-option v-for="val in statusOption"
                       :key="val.id"
                       :label="val.name"
                       :value="val.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select multiple
                     collapse-tags
                     v-model="filter.productType"
                     placeholder="Product"
                     size="small"
                     @change="conditionSearch()"
                     style="width:100%;">
            <el-option v-for="(val,index) in productOption"
                       :key="index"
                       :label="val"
                       :value="val"></el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-input type="text"
                    v-model.trim="filter.searchName"
                    size="small"
                    placeholder="Input Model、SN or GatewayID"
                    @keyup.enter.native="conditionSearch()">
            <i slot="suffix"
               class="el-input__icon el-icon-search"
               @click="conditionSearch()"></i>
          </el-input>
        </el-col>
        <el-col :span="1">
          <el-button size="small"
                     class="button_reset"
                     @click="handleReaet">
            <svg-icon icon-class="reset"></svg-icon>
          </el-button>
        </el-col>
      </el-row>
      <div class="background"></div>
      <!-- 表格区域 -->
      <div class="sp_table">
        <el-row>
          <el-col :span="2"
                  style="display:flex;">
            <el-button type="primary"
                       size="small"
                       @click="addAssets">
              <svg-icon icon-class="add"></svg-icon>&nbsp;&nbsp;Add Asset
            </el-button>
            <el-button plain
                       size="small"
                       @click="handleSearch(filter)">
              <svg-icon class="table-btn-svg"
                        icon-class="refresh"></svg-icon>&nbsp;&nbsp;Refresh
            </el-button>
            <el-button plain
                       size="small"
                       @click="handleExport(filter)">
              <svg-icon class="table-btn-svg"
                        icon-class="export"></svg-icon>&nbsp;&nbsp;Export
            </el-button>
            <el-button plain
                       size="small"
                       @click="showShareDialog">
              <svg-icon class="table-btn-svg"
                        icon-class="share"></svg-icon>&nbsp;&nbsp;Share
            </el-button>
            <el-button plain
                       size="small"
                       @click="handleUnshare">
              <svg-icon class="table-btn-svg"
                        icon-class="unshare"></svg-icon>&nbsp;&nbsp;Stop Sharing
            </el-button>
          </el-col>
        </el-row>

        <el-row class="assest-table-content"
                style="margin-top:8px;">
          <el-col class="table-content"
                  :span="24">
            <el-table :data="tableDate"
                      :header-cell-style="setHeadeStyle"
                      :cell-style="cellStyle"
                      size="dedium"
                      class="table"
                      border
                      ref="myTable"
                      tooltip-effect="dark"
                      v-loading="tableLoading"
                      @selection-change="handleSelectionChange">
              <el-table-column type="selection"
                               align="center"></el-table-column>
             
              <el-table-column label="Gateway ID"
                               show-overflow-tooltip
                               :render-header="renderHeader">
                               <template slot-scope="scope">
                  <span style="color:#007aff; cursor: pointer;"
                        @click="showDeviceDetails(scope.row)">{{scope.row.deviceId}}</span>
                </template>
                              </el-table-column>
                               <el-table-column label="Serial Number"
                               show-overflow-tooltip
                               prop="sn"
                               :render-header="renderHeader">
              
              </el-table-column>
              <el-table-column label="Cloud License ID"
                               prop="licenseId"
                               show-overflow-tooltip
                               :render-header="renderHeader"></el-table-column>
              <el-table-column label="Product"
                               show-overflow-tooltip
                               width="80">
                <template slot-scope="scope">
                  <span>{{scope.row.model.indexOf("NSF")==0 ? "NSF" : scope.row.productType}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Model"
                               prop="model"
                               show-overflow-tooltip
                               :render-header="renderHeader"></el-table-column>
              <el-table-column label="Status"
                               :show-overflow-tooltip="true"
                               :render-header="renderHeader">
                <template slot-scope="scope">
                  <span :style="statusStyle[scope.row.licStatus]">{{deviceStatus[scope.row.licStatus]}}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="Order No."
                               prop="orderId"
                               width="120"
                               show-overflow-tooltip
                               :render-header="renderHeader"></el-table-column> -->
              <el-table-column label="Added Time"
                               show-overflow-tooltip
                               :render-header="renderHeader">
                <template slot-scope="scope">
                  <span>{{moment(scope.row.createTime).format('YYYY-MM-DD')}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Updated Time"
                               show-overflow-tooltip
                               :render-header="renderHeader">
                <template slot-scope="scope">
                  <span>{{moment(scope.row.updateTime).format('YYYY-MM-DD')}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Expired Date"
                               show-overflow-tooltip
                               :render-header="renderHeader">
                <template slot-scope="scope">
                  <span>{{scope.row.softwareUpdateTime?moment(scope.row.softwareUpdateTime).format('YYYY-MM-DD'):'-'}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Share (Partner)"
                               show-overflow-tooltip
                               :render-header="renderHeader">
                <template slot-scope="scope">
                  <span>{{scope.row.shareChannelName?scope.row.shareChannelName:'-'}}</span>
                </template>
              </el-table-column>

              <el-table-column label="Remark"
                               show-overflow-tooltip
                               :render-header="renderHeader">
                <template slot-scope="scope">
                  <span>{{scope.row.remark?scope.row.remark:'-'}}</span>
                </template>
              </el-table-column>

              <el-table-column label="Auto Activation"
                               align="left"
                               show-overflow-tooltip
                               :render-header="renderHeader">
                <template slot-scope="scope">
                  <span>{{scope.row.autoActivate === 1 ? 'Enabled' : 'Disabled'}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Operation"
                               align="left"
                               fixed="right"
                               width="160">
                <template slot-scope="scope">
                  <el-button type="text"
                             class="text-btn active-btn"
                             @click.native="handelUpdate(scope.row)">{{scope.row.licStatus==0?'Activate':'Update'}}</el-button>

                  <el-dropdown trigger="click">
                    <el-button class="text-btn"
                               type="text">More<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="editActivate(scope.row)">Edit</el-dropdown-item>
                      <el-dropdown-item :disabled="scope.row.licStatus==0||scope.row.licStatus==4"
                                        @click.native="handleDownload(scope.row.id)">Download License</el-dropdown-item>
                      <el-dropdown-item v-if="isSuperAdmin"
                                        @click.native="handleUnbind(scope.row)">Unbind</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </el-col>

          <el-col :span="24"
                  class="pagination"
                  style="text-align:right;">
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :page-sizes="pageSizes"
                           :current-page="filter.pageNumber"
                           :page-size="filter.pageSize"
                           :disabled="total < 10"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
          </el-col>
        </el-row>
      </div>
      <el-dialog title="Edit"
                 :visible.sync="dialogVisible"
                 width="33%"
                 :before-close="handleClose">
        <div class="label-content">
          <div class="activate-content">
            <span class="label-icon"></span>
            <span class="label">Activation</span>
          </div>
          <p class="activation-message">Automatic Activation Enable. When Automatic Activation is enabled,
            the device will be activated automatically after it connects to the Internet.
            Automatic activation is not available for software products.</p>
          <div class="radio">
            <el-radio v-model="radio"
                      :label="1">Enabled</el-radio>
            <el-radio v-model="radio"
                      :label="0">Disabled</el-radio>
          </div>
          <div class="remark-content">
            <span class="label-icon"></span>
            <span class="label">Remark</span>
          </div>
          <div class="remark-input">
            <el-input type="textarea"
                      :rows="2"
                      placeholder="Please input remark"
                      v-model="remark">
            </el-input>
          </div>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button type="primary"
                     @click="submitActivate">OK</el-button>
          <el-button @click="dialogVisible=false">Cancel</el-button>
        </span>
      </el-dialog>
    </div>
    <add-device class="sp_addDevice"
                v-if="showAddDevice"
                :addDeviceVisible.sync="addDeviceVisible"
                @addDeviceChildMsg="addDeviceChildMsg"></add-device>
    <device-share v-if="shareMsg.show"
                  :shareMsg="shareMsg"
                  @shareChildMsg="shareChildMsg"></device-share>
    <device-details v-if="detailsMsg.show"
                    class="sp_Details"
                    @detailsChildMsg="detailsChildMsg"
                    :detailsMsg="detailsMsg"></device-details>
  </div>
</template>

<script>
import { tableMixis } from '@/mixins/tableMixis.js'
import headeTitle from '../../components/headeTitle.vue'
import AddDevice from '../myAssetsList/addDevice.vue'
import {
  getAssetsList,
  updateAutoActivate,
  getProductTypeList,
  exprotDeviceApi,
  unshareDeviceApi,
  downloadLicenseApi,
  getDeviceNotice,
  unbindDeviceApi,
} from '@/api/assetsList.js'
import moment from 'moment'
import DeviceShare from './deviceShare.vue'
import DeviceDetails from './deviceDetails.vue'
export default {
  components: { headeTitle, AddDevice, DeviceShare, DeviceDetails },
  name: 'myAssetsList',
  mixins: [tableMixis],
  data() {
    return {
      title: 'My Assets List',
      filter: {
        addedTime: [],
        expiredTime: [],
        licStatus: '',
        productType: [],
        searchName: '',
        pageSize: 10,
        pageNumber: 1,
      },
      addDeviceVisible: false,
      defualtFilter: {},
      tableDate: [],
      total: 0,
      showAddDevice: false,
      tableLoading: false,
      showContent: true,
      deviceStatus: {
        0: 'Inactivated',
        1: 'Activated',
        2: 'To be Updated',
        4: 'Expired',
      },
      statusStyle: {
        0: {
          background: '#F4A12D',
          color: '#fff',
          padding: '0px 10px',
          height: '22px',
          'line-height': '22px',
          display: 'inline-block',
          borderRadius: '45px',
        },
        1: {
          background: '#32C093',
          color: '#fff',
          padding: '0px 10px',
          height: '22px',
          'line-height': '22px',
          display: 'inline-block',
          borderRadius: '45px',
        },
        2: {
          background: '#007AFF',
          color: '#fff',
          padding: '0px 10px',
          height: '22px',
          'line-height': '22px',
          display: 'inline-block',
          borderRadius: '45px',
        },
        4: {
          background: '#79828C',
          color: '#fff',
          padding: '0px 10px',
          height: '22px',
          'line-height': '22px',
          display: 'inline-block',
          borderRadius: '45px',
        },
      },
      productOption: [],
      statusOption: [
        { id: 0, name: 'Inactivated' },
        { id: 1, name: 'Activated' },
        { id: 2, name: 'To be Updated' },
        { id: 4, name: 'Expired' },
      ],
      shareMsg: {
        message: 'Please select the partner you want to share the assets.',
        title: 'Share',
        show: false,
        row: [],
      },
      detailsMsg: {
        show: false,
        row: {},
        toLicense: false,
      },
      dialogVisible: false,
      radio: 1,
      remark: '',
      currentEditActivate: {},
      showDeviceNotice: false,
      deviceNotice: ''
    }
  },

  methods: {
    //设置表格样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (column.label === 'Status') {
        return { color: '#ffffff' }
      }
    },
    //表头样式
    renderHeader(h, data) {
      return h('span', [
        h(
          'el-tooltip',
          {
            attrs: {
              class: 'item',
              effect: 'dark',
              content: data.column.label,
              placement: 'top',
              color: '#fff!important',
            },
          },
          [h('span', data.column.label)]
        ),
      ])
    },
    //打开添加设备页面
    addAssets() {
      this.addDeviceVisible = true
      this.showAddDevice = true
      this.$store.commit('LOAD_ASSETS_PAGE', false)
    },
    //编辑设备激活
    editActivate(val) {
      this.dialogVisible = true
      this.currentEditActivate = val
      this.radio = this.currentEditActivate.autoActivate
      this.remark = this.currentEditActivate.remark
    },
    handleClose() {
      this.dialogVisible = false
    },

    //提交设备激活
    submitActivate() {
      const params = {
        id: this.currentEditActivate.id,
        autoActivate: this.radio,
        remark: this.remark,
      }
      updateAutoActivate(params).then((res) => {
        this.handleSearch(this.filter)
      })
      this.dialogVisible = false
    },
    //添加设备传值
    addDeviceChildMsg(data) {
      this.handleSearch(this.filter)
      this.addDeviceVisible = false
      this.showAddDevice = false
    },

    //搜索
    handleSearch(data) {
      this.tableLoading = true
      let params = JSON.parse(JSON.stringify(data))
      params.createBeginTime =
        params.addedTime && params.addedTime.length > 0
          ? params.addedTime[0]
          : undefined
      params.createEndTime =
        params.addedTime && params.addedTime.length > 0
          ? params.addedTime[1]
          : undefined
      params.expiredBeginTime =
        params.expiredTime && params.expiredTime.length > 0
          ? params.expiredTime[0]
          : undefined
      params.expiredEndTime =
        params.expiredTime && params.expiredTime.length > 0
          ? params.expiredTime[1]
          : undefined
      params.licStatus = params.licStatus !== '' ? params.licStatus : undefined
      params.searchName = params.searchName.replace(/\s*/g, '')
      delete params.addedTime
      delete params.expiredTime
      getAssetsList(params)
        .then((res) => {
          this.tableDate = res.rows.rows
          this.total = res.rows.total
          this.tableLoading = false
        })
        .catch(() => {
          this.tableDate = []
          this.total = 0
          this.tableLoading = false
        })
    },

    //重置搜索
    handleReaet() {
      this.filter = JSON.parse(JSON.stringify(this.defualtFilter))
      this.handleSearch(this.filter)
    },

    //获取产品线
    getproductList() {
      getProductTypeList().then((res) => {
        this.productOption = res.rows
      })
    },

    //获取设备公告
    getDeviceNotice() {
      getDeviceNotice().then((res) => {
        this.deviceNotice = res.rows.value
        if (this.deviceNotice) {
          this.showDeviceNotice = true
        }
      })
    },

    //导出设备
    handleExport(data) {
      let params = JSON.parse(JSON.stringify(data))
      params.createBeginTime =
        params.addedTime.length > 0 ? params.addedTime[0] : undefined
      params.createEndTime =
        params.addedTime.length > 0 ? params.addedTime[1] : undefined
      params.expiredBeginTime =
        params.expiredTime.length > 0 ? params.expiredTime[0] : undefined
      params.expiredEndTime =
        params.expiredTime.length > 0 ? params.expiredTime[1] : undefined
      params.licStatus = params.licStatus !== '' ? params.licStatus : undefined
      delete params.addedTime
      delete params.expiredTime
      exprotDeviceApi(params).then((res) => {
        const a = document.createElement('a')
        const blob = new Blob([res])
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', 'Device List.xlsx')
        a.click()
        URL.revokeObjectURL(objectUrl)
      })
    },

    //打开分享页面
    showShareDialog() {
      if (this.shareMsg.row.length > 1) {
        let DeviceLength = this.shareMsg.row.length
        let result = 0
        this.shareMsg.row.forEach((val) => {
          if (val.shareChannelName) {
            result += 1
          }
        })
        if (result !== DeviceLength && result !== 0) {
          this.$message({
            type: 'warning',
            message: 'Some devices have already been shared.',
          })
        } else if (result == DeviceLength && result !== 0) {
          this.$message({
            type: 'warning',
            message: 'The devices have already been shared.',
          })
        } else {
          this.shareMsg.show = true
        }
      } else if (this.shareMsg.row.length == 1) {
        if (this.shareMsg.row[0].shareChannelName) {
          this.$message({
            type: 'warning',
            message: 'This device has already been shared.',
          })
        } else {
          this.shareMsg.show = true
        }
      } else {
        this.$message({
          type: 'warning',
          message: 'Please make a selection before sharing.',
        })
      }
    },

    //关闭分享页面传值
    shareChildMsg(data) {
      if (data.isSave) {
        this.handleSearch(this.filter)
      }
      this.shareMsg.show = false
    },

    //表格多选
    handleSelectionChange(data) {
      this.shareMsg.row = data
    },

    //取消设备分享
    handleUnshare() {
      if (this.shareMsg.row.length > 1) {
        let DeviceLength = this.shareMsg.row.length
        let result = 0
        this.shareMsg.row.forEach((val) => {
          if (!val.shareChannelName) {
            result += 1
          }
        })
        if (result !== DeviceLength && result !== 0) {
          this.$message({
            type: 'warning',
            message: 'Some devices have not been shared.',
          })
        } else if (result == DeviceLength && result !== 0) {
          this.$message({
            type: 'warning',
            message: 'The devices have not been shared.',
          })
        } else {
          let params = []
          this.shareMsg.row.forEach((val) => {
            params.push(val.id)
          })
          this.$confirm('Confirm to unshare?', 'Hint', {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            type: 'warning',
          })
            .then(() => {
              unshareDeviceApi(params).then((res) => {
                this.$message({
                  type: 'success',
                  message: 'Unshare successfully',
                })
                this.handleSearch(this.filter)
              })
            })
            .catch(() => {
              console.log(1)
            })
        }
      } else if (this.shareMsg.row.length == 1) {
        if (!this.shareMsg.row[0].shareChannelName) {
          this.$message({
            type: 'warning',
            message: 'This device has not been shared.',
          })
        } else {
          let params = []
          params.push(this.shareMsg.row[0].id)
          this.$confirm('Confirm to unshare?', 'Hint', {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            type: 'warning',
          })
            .then(() => {
              unshareDeviceApi(params).then((res) => {
                this.$message({
                  type: 'success',
                  message: 'Unshare successfully',
                })
                this.handleSearch(this.filter)
              })
            })
            .catch(() => {
              console.log(1)
            })
        }
      } else {
        this.$message({
          type: 'warning',
          message: 'Please make a selection before stopping sharing.',
        })
      }
    },

    //超管解绑设备
    handleUnbind(row) {
      this.$confirm(
        `Are you sure you want to unbind this device "${row.deviceId || row.sn}"?`,
        'Hint',
        {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      )
        .then(() => {
          unbindDeviceApi(row.id).then((res) => {
            this.$message({
              type: 'success',
              message: 'Unbind successfully',
            })
            this.handleSearch(this.filter)
          })
        })
        .catch(() => {})
    },

    //打开详情页
    showDeviceDetails(data) {
      this.detailsMsg.show = true
      this.showContent = false
      this.detailsMsg.row = data
      this.detailsMsg.toLicense = false
      this.$store.commit('LOAD_ASSETS_PAGE', false)
    },

    //打开激活页面
    handelUpdate(data) {
      this.detailsMsg.row = data
      this.detailsMsg.show = true
      this.showContent = false
      this.detailsMsg.toLicense = true
      this.$store.commit('LOAD_ASSETS_PAGE', false)
    },

    //关闭详情页传值
    detailsChildMsg() {
      this.detailsMsg.show = false
      this.showContent = true
      this.handleSearch(this.filter)
    },

    //下载license文件
    handleDownload(id) {
      let params = { id: id }
      downloadLicenseApi(params).then((res) => {
        let fileName = res.headers['content-disposition']
          .split(';')[1]
          .split('=')[1]
        const a = document.createElement('a')
        const blob = new Blob([res.data])
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', fileName)
        a.click()
        URL.revokeObjectURL(objectUrl)
      })
    },
  },
  created() {
    this.handleSearch(this.filter)
    this.getproductList()
    this.getDeviceNotice()
    this.defualtFilter = JSON.parse(JSON.stringify(this.filter))
  },
  mounted() {
    this.$refs.myTable.$el.children[1].style.width = 'calc( 100% - 10px)'
  },
  computed: {
    moment() {
      return moment
    },
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin
    },
  },
}
</script>

<style scoped lang="scss">
.sp_myAssetsList {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  position: relative;
  .content {
    height: 100%;
  }
  .sp_Details {
    position: absolute;
    top: 0;
    left: 0;
    background: #f0f3f7;
    z-index: 666;
    width: 100%;
    height: 100%;
  }
  .background {
    height: 8px;
    background-color: #f0f3f7;
  }
  .sp_table {
    width: 100%;
    height: calc(100% - 80px);
    background: #fff;
    padding: 16px 16px 16px;
    .assest-table-content {
      height: calc(100% - 39px);
      .table-content {
        height: calc(100% - 48px);
        .table {
          height: 100%;
          /deep/.el-table__body-wrapper {
            height: calc(100% - 41px);
            overflow-y: auto;
            overflow-x: auto;
          }
          /deep/.el-table__fixed-right .el-table__fixed-body-wrapper,
          .el-table__fixed-right .el-table__fixed-footer-wrapper,
          .el-table__fixed-right .el-table__fixed-header-wrapper {
            // overflow-y: auto !important;
            height: calc(100% - 41px) !important;
            // pointer-events: none !important;
          }
        }
      }
      .pagination {
        margin-right: 0 !important;
        .el-pagination {
          height: 48px;
          margin-right: 0px !important;
          padding-right: 0px !important;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          /deep/.el-pagination__editor {
            margin-left: 10px !important;
            padding: 0 !important;
          }
          /deep/.el-pager li.disabled {
            color: #ffffff !important;
          }
        }
      }
    }
  }
  /deep/.el-table thead {
    font-weight: 500 !important;
  }
  .label-content {
    margin: 16px 4px;
    span {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #13161a;
      letter-spacing: 0;
    }
    .label-icon {
      display: inline-block;
      height: 14px;
      width: 4px;
      background-color: #2684ff;
      margin: 0 8px;
    }
    .label {
      display: inline-block;
      height: 30px;
      line-height: 30px;
    }
    .activate-content {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .remark-content {
      margin-top: 16px;
      margin-bottom: 8px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .remark-input {
      margin: 0 20px;
    }
    .activation-message {
      margin: 0 20px;
      color: #77808c;
      line-height: 22px;
      margin-bottom: 12px;
      word-break: break-word;
      font-size: 14px;
    }
    .radio {
      height: 32px;
      line-height: 32px;
      margin: 0 20px;
      font-size: 14px;
      font-weight: 400;
      /deep/.el-radio__label {
        font-size: 14px !important;
        font-weight: 400 !important;
      }
    }
  }
}
.text-btn {
  padding: 0px !important;
}
.active-btn {
  margin-right: 20px;
}
.button_reset {
  padding: 0;
  width: 38px;
  height: 32px;
}
::v-deep .el-table th.el-table__cell > .cell {
  // word-break: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/deep/.el-table-column--selection .cell {
  padding-right: 8px !important;
}
.el-button:hover {
  .table-btn-svg {
    color: #2684ff !important;
  }
}
</style>
<style lang="scss">
.el-dialog__footer {
  padding: 16px 20px !important;
}
.el-dialog__body {
  padding: 0 20px;
}
</style>